import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import BookingDialog from "./BookingDialog";

const brl = (v) => v.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });

export default function ChaletCard({ nome, categoria }) {
  const [idx, setIdx] = useState(0);
  const [aberto, setAberto] = useState(false);
  const totalFotos = categoria.fotos.length;
  const slug = nome.toLowerCase();
  const prev = () => setIdx((i) => (i - 1 + totalFotos) % totalFotos);
  const next = () => setIdx((i) => (i + 1) % totalFotos);
  const extras = categoria.comodidades.length - 6;

  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6 }}
      className="group flex flex-col border border-[#1C3026]/15 bg-white"
      data-testid={`chale-card-${slug}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={categoria.fotos[idx]}
          alt={`Chalé ${nome} — foto ${idx + 1}`}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          data-testid={`chale-foto-${slug}`}
        />
        <button
          onClick={prev}
          aria-label="Foto anterior"
          className="absolute left-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center bg-[#F6F5F2]/90 text-[#1C3026] transition-colors hover:bg-white"
          data-testid={`chale-foto-prev-${slug}`}
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
        <button
          onClick={next}
          aria-label="Próxima foto"
          className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center bg-[#F6F5F2]/90 text-[#1C3026] transition-colors hover:bg-white"
          data-testid={`chale-foto-next-${slug}`}
        >
          <ChevronRight className="h-5 w-5" />
        </button>
        <span
          className="absolute bottom-3 right-3 bg-[#0f1f17]/70 px-2 py-1 text-xs text-[#F6F5F2]"
          data-testid={`chale-foto-contador-${slug}`}
        >
          {idx + 1} / {totalFotos}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#8C5A40]">
          {categoria.titulo}
        </p>
        <h3 className="mt-2 text-2xl font-bold md:text-3xl">Chalé {nome}</h3>
        <p className="mt-3">
          <span className="text-xl font-bold">{brl(categoria.diaria)}</span>{" "}
          <span className="text-sm text-[#5B7065]">/ noite</span>
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          {categoria.comodidades.slice(0, 6).map((c) => (
            <span
              key={c}
              className="border border-[#1C3026]/20 px-2 py-1 text-[10px] uppercase tracking-wider text-[#5B7065]"
            >
              {c}
            </span>
          ))}
          <span className="bg-[#EBE8E0] px-2 py-1 text-[10px] uppercase tracking-wider text-[#1C3026]">
            +{extras} comodidades
          </span>
        </div>
        <button
          onClick={() => setAberto(true)}
          className="mt-6 w-full bg-[#1C3026] py-3.5 text-xs font-bold uppercase tracking-[0.2em] text-[#F6F5F2] transition-colors hover:bg-[#8C5A40]"
          data-testid={`chale-reservar-${slug}`}
        >
          Reservar este chalé
        </button>
      </div>
      <BookingDialog aberto={aberto} onFechar={() => setAberto(false)} nome={nome} categoria={categoria} />
    </motion.article>
  );
}
